__turbopack_context__.v({
  "canvas": "Trace-module__eUah_W__canvas",
});
